export default __webpack_public_path__ + "static/media/5.dc8c7bc3.jpg";